import { UppKonvaShape } from '../upp-konva-shape';
import type { UppKonvaFootballShapeOptions } from '../upp-konva-options';

/** Foosball table shape. */
export class UppKonvaFootballShape extends UppKonvaShape {
    // 1. Type contract
    readonly kind = 'FOOTBALL' as const;

    // 2. Lifecycle
    constructor(opts: UppKonvaFootballShapeOptions) {
        super({ ...opts, data: {} });
    }
}
